<template>
  <nav :class="classes" class="navbar navbar-banner">
    <div :class="containerClasses">
      <slot name="brand"></slot>
      <div class="nav-action-wrapper d-lg-none">
        <router-link to="/store" aria-label="Search for artwork in the store">
          <i class="fa fa-search search-icon" />
        </router-link>
        <router-link v-if="isLoggedIn" to="/mycollections">
          <i class="fa fa-heart search-icon" />
        </router-link>
        <!-- <router-link
          v-if="isLoggedIn"
          class="notification-button"
          to="/notifications"
        >
          <i class="fas fa-bell search-icon" />
          <span
            v-if="unreadNotifications > 0"
            class="badge badge-sm badge-circle bg-red text-white notification-badge"
            >{{ unreadNotifications }}</span
          >
        </router-link> -->
        <button class="cart-button" @click="handleCartClick">
          <i class="fa-solid fa-cart-shopping cart-icon"></i>
          <span
            v-if="stripe.cartItems.length > 0"
            class="badge badge-sm badge-circle bg-red text-white notification-badge"
            >{{ cartCount }}</span
          >
        </button>
      </div>
      <slot name="toggle-button">
        <button
          class="navbar-toggler collapsed d-none"
          v-if="hasMenu"
          type="button"
          @click="toggleMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
        </button>
      </slot>

      <button class="navbar-toggler" @click.stop="toggleMenu">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="navbar-collapse navbar-custom-collapse collapse show"
        :class="menuClasses"
        v-show="show"
        v-click-outside="closeMenu"
      >
        <slot :close-menu="closeMenu"></slot>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "base-nav",
  props: {
    show: {
      type: Boolean,
      default: false,
      description:
        "Whether navbar menu is shown (valid for viewports < specified by `expand` prop)",
    },
    transparent: {
      type: Boolean,
      default: false,
      description: "Whether navbar is transparent",
    },
    expand: {
      type: String,
      default: "lg",
      description: "Breakpoint where nav should expand",
    },
    menuClasses: {
      type: [String, Object, Array],
      default: "",
      description:
        "Navbar menu (items) classes. Can be used to align menu items to the right/left",
    },
    containerClasses: {
      type: [String, Object, Array],
      default: "container-fluid",
      description:
        "Container classes. Can be used to control container classes (contains both navbar brand and menu items)",
    },
    type: {
      type: String,
      default: "",
      validator(value) {
        return [
          "",
          "dark",
          "success",
          "danger",
          "warning",
          "white",
          "primary",
          "light",
          "info",
          "vue",
        ].includes(value);
      },
      description: "Navbar color type",
    },
  },
  model: {
    prop: "show",
    event: "change",
  },
  computed: {
    // ...mapState(["isLoggedIn", "notifications"]),
    ...mapState(["isLoggedIn", "stripe"]),
    classes() {
      let color = `bg-${this.type}`;
      let classes = [
        { "navbar-transparent": this.transparent },
        { [`navbar-expand-${this.expand}`]: this.expand },
      ];
      if (this.position) {
        classes.push(`navbar-${this.position}`);
      }
      if (!this.transparent) {
        classes.push(color);
      }
      return classes;
    },
    hasMenu() {
      return this.$slots.default;
    },
    cartCount() {
      const designCount = this.stripe.cartItems.filter(
        (i) => !!i.design_service
      ).length;
      const designOnlyCount = this.stripe.cartItems.filter(
        (i) => !!i.is_design_service_only
      ).length;
      return this.stripe.cartItems.length + designCount - designOnlyCount;
    },
    // unreadNotifications() {
    //   const count = this.notifications.filter(
    //     (notification) => notification.status === "unread"
    //   ).length;

    //   return count > 99 ? 99 : count;
    // },
  },
  methods: {
    handleCartClick() {
      this.$store.commit("showCart", true);
    },
    toggleMenu() {
      this.$emit("change", !this.show);
    },
    closeMenu() {
      this.$emit("change", false);
    },
  },
};
</script>
<style lang="scss">
// .navbar-banner {
//   top: 40px !important;
// }
.nav-action-wrapper {
  display: flex;
  justify-content: flex-end;
  flex: 1;

  .search-icon,
  .cart-icon {
    color: white;
    padding: 12px;
    border-radius: 50px;
    transition: all 0.15s ease-in-out;

    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }

  .cart-button {
    background: none;
    border: none;

    &:focus,
    &:hover,
    &:active {
      outline: 0;
    }
  }

  .notification-button,
  .cart-button {
    position: relative;

    .notification-badge {
      position: absolute;
      top: -2px;
      right: 2px;
      font-size: 10px;
    }
  }
}

// @media (max-width: 575.98px) {
//   .nav-action-wrapper {
//     .notification-button,
//     .cart-button {
//       .notification-badge {
//         top: -2px;
//         right: 2px;
//       }
//     }
//   }
// }
</style>
